module.exports = __webpack_public_path__ + "img/BG131134023.9dccd17a.svg";